import React, { useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { useDispatch, useSelector } from "react-redux";
import { MenuLink, MobileMainMenu, SiteLogo, DrawerBox, DrawerDivider, Humburgger, HumburggerClose, MenuButton } from "../styles";


const MobileMenu = (props) => {
  const currentTheme = useSelector((state) => state.LDTheme.value)
  const dispatch = useDispatch();
  const [state, setState] = useState({ left: false });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) { return; }
    setState({ ...state, [anchor]: open });
  };
  return (
    <MobileMainMenu>
      <MenuLink href="/" p="15px 0 15px">
        <SiteLogo src="./Image/Logo.png" style={{width:"55px"}} alt="Logo"  />
      </MenuLink>
      <MenuButton onClick={toggleDrawer("left", true)}>
        {state["left"] ? (
          <HumburggerClose>Close</HumburggerClose>
        ) : (
          <Humburgger></Humburgger>
        )}
      </MenuButton>
      <Drawer
        anchor="left"
        open={state["left"]}
        onClose={toggleDrawer("left", false)}
      >
        <DrawerBox
          role="presentation"
          onClick={toggleDrawer("left", false)}
          onKeyDown={toggleDrawer("left", false)}
        >
          <DrawerDivider>
            <MenuLink p="15px 0" href="/">
              <SiteLogo src="./Image/Logo.png"  style={{width:"55px"}} alt="Logo" />
            </MenuLink>
            <Divider />
            <List>
              {props.menuList.map((value, i) => <MenuLink p="15px 0" key={i} onClick={value.onClick} href={value.link} target={value.target} className={value.customClass + " d-block"}><span /><span /><span /><span />{value.title}</MenuLink>)}
            </List>
          </DrawerDivider>
          <DrawerDivider>
            <List>
              
            </List>
          </DrawerDivider>
        </DrawerBox>
      </Drawer>
    </MobileMainMenu>
  );
}

export default MobileMenu;

